import { MutationTuple } from '@apollo/client';
import {
  RemoveChannelMemberMutation,
  RemoveChannelMemberMutationVariables,
  useRemoveChannelMemberMutation,
} from 'shared/types/graphql';

const useRemoveChannelMember = (): MutationTuple<RemoveChannelMemberMutation, RemoveChannelMemberMutationVariables> => {
  return useRemoveChannelMemberMutation({
    refetchQueries: ['getPetParentChannels', 'getChannelListChannels', 'getClinicChannelViewChannel'],
  });
};

export default useRemoveChannelMember;
